import { render, staticRenderFns } from "./TaskRemovedSubtask.vue?vue&type=template&id=4eb61bf9&scoped=true"
import script from "./TaskRemovedSubtask.vue?vue&type=script&lang=js"
export * from "./TaskRemovedSubtask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb61bf9",
  null
  
)

export default component.exports